import BrandsPage from 'src/dispensary/core-menu/brands';
import { CoreMenuLayout } from 'components/layouts/core-menu-layout';
import { getDispensaryServerSideProps } from 'src/utils/ssr/get-dispensary-server-side-props';

export const getServerSideProps = getDispensaryServerSideProps;

BrandsPage.layout = CoreMenuLayout;
export default BrandsPage;
